module.exports = __webpack_public_path__ + "img/p2-p2-diaoxiang1.49731fb6.png";